import { authHeader, handleResponse } from '../helpers';
export const roleService = {
    createRole,
    updateRole,
    fetchRoleData,
    inActiveRow,
    fetchRoleDLL,
    fetchPageData,
    updateRolePermission
};

function createRole(data) {

    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };
    return fetch(`${process.env.REACT_APP_API_URL}RoleMaster/CreateRole`, requestOptions)
        .then(handleResponse);
}

function updateRole(data) {

    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };
    return fetch(`${process.env.REACT_APP_API_URL}RoleMaster/UpdateRole`, requestOptions)
        .then(handleResponse);
}

function fetchRoleData(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };
    return fetch(`${process.env.REACT_APP_API_URL}RoleMaster/GetRoles`, requestOptions)
        .then(handleResponse);
}

function inActiveRow(roleId, isActive) {

    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(`${process.env.REACT_APP_API_URL}RoleMaster/InActiveRow/${roleId}/${isActive}`, requestOptions)
        .then(handleResponse);
}

function fetchRoleDLL(userId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`${process.env.REACT_APP_API_URL}RoleMaster/GetRoleDLL/${userId}`, requestOptions)
        .then(handleResponse);
}

function fetchPageData(roleId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`${process.env.REACT_APP_API_URL}RoleMaster/GetPages/${roleId}`, requestOptions)
        .then(handleResponse);
}

function updateRolePermission(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };
    return fetch(`${process.env.REACT_APP_API_URL}RoleMaster/UpdatePagePermission`, requestOptions)
    .then(handleResponse);
}
